<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div style="width: 100%">
        <ServiceInfo></ServiceInfo>

        <div class="col-lg-10 col-md-11 col-sm-12 m-auto jipvio-rad">
          <!-- 본인인증 -->
          <div class="">
            <span id="propInfoTitle">1. 의뢰 정보</span>
            <p id="step4p1">1단계에서 작성했던 내용이 그대로 입력됩니다.</p>
            <Identification
              ref="confirm"
              :Disabled="Input_Select_Disabled"
            ></Identification>
          </div>

          <!--sohyun-->
          <!-- 매물 위치 정보 -->
          <LocationInfo
            ref="location"
            :Disabled="Input_Select_Disabled"
          ></LocationInfo>

          <!-- 건축물 정보 -->
          <Building-Info ref="Building"></Building-Info>

          <!--거래 정보 -->
          <Contract-Info
            ref="contrInfo"
            @SendContractData="GetContractData"
          ></Contract-Info>

          <!-- 상세 정보 -->
          <Detail-Info
            ref="DetailInfo"
            @SendDetailData="GetDetailData"
          ></Detail-Info>

          <!--부가 정보 -->
          <Extra-Info
            ref="ExtraInfo"
            @SendExtraData="GetExtraData"
          ></Extra-Info>

          <!-- ======================================================================= -->
          <!--추가 설명 -->
          <Add-Explanation @extrExpl="extrExpl = $event"></Add-Explanation>

          <!--추가 정보 동의 -->
          <Add-Info-Consent
            @oneHouseAgr="oneHouseAgr = $event"
            @shareHouseAgr="shareHouseAgr = $event"
          ></Add-Info-Consent>

          <!-- 파일 업로드 -->
          <File-Upload
            ref="FileUpload"
            @G_Img_File="G_Img_File = $event"
          ></File-Upload>

          <!--기타 의견 -->
          <OtherOpinions @etcComment="etcComment = $event"></OtherOpinions>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfo.vue";
import Identification from "@/pages/components/Jipvio/Step1_Identification.vue";
import LocationInfo from "@/pages/components/Jipvio/Step1_LocationInfo.vue";
import BuildingInfo from "@/pages/components/Jipvio/Step4_BuildingInfo.vue";
import ContractInfo from "@/pages/components/Jipvio/Step4_ContractInfo.vue";
import DetailInfo from "@/pages/components/Jipvio/Step4_DetailInfo.vue";
import ExtraInfo from "@/pages/components/Jipvio/Step4_ExtraInfo.vue";
import AddExplanation from "@/pages/components/Jipvio/Step4_AddExplanation.vue";
import AddInfoConsent from "@/pages/components/Jipvio/Step4_AddInfoConsent.vue";
import FileUpload from "@/pages/components/Jipvio/Step4_FileUpload.vue";
import OtherOpinions from "@/pages/components/Jipvio/Step4_OtherOpinions.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { FormGroupInput as FgInput } from "@/components";
import { createNamespacedHelpers, mapGetters } from "vuex";
import filestoreApi from "@/service/filestore";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

extend("required", required);

import { Message } from "element-ui";

export default {
  components: {
    ServiceInfo,
    Identification,
    BuildingInfo,
    LocationInfo,
    ContractInfo,
    DetailInfo,
    ExtraInfo,
    AddExplanation,
    AddInfoConsent,
    FileUpload,
    OtherOpinions,
    FgInput
  },
  data() {
    return {
      Input_Select_Disabled: true, //Step1컴포넌트 input,select태그 비활성화

      jipvioMarker: null,
      jipvioMap: null,
      jipvioGeocoder: null,
      locationInfo: {},

      possibleMoveDate: null, // 입주가능일
      imdMove: false, // 즉시입주(true, false)
      loanYn: null, //전세자금대출 가능여부

      TNORooms: null, //방 수
      TNORoomsDirect: false, // 방 수 직접선택 체크박스
      TNOBathRooms: null, //욕실 수
      TNOBathRoomsDirect: null, //욕실 수 직접선택 체크박스
      eleYn: null, // 승강기 여부
      heatingType: null, //난방방식
      heatingFuel: null, //난방연료
      entStructure: null, //현관구조
      directionStd: null, //방향 기준
      direction: null, //방향
      verandaYn: false, //베란다 체크박스
      balconyYn: false, // 발코니 체크박스
      parkingYn: null, // 주차가능여부
      PknPerFmly: null, // 가구당 주차가능대수
      maintenanceFee: null, //관리비
      maintenList: [], //선택된 관리비 포함항목
      useFeeYn: null, //사용료
      useFeeList: [], //사용료 포함내역

      optionYn: null, //옵션유무
      optionList: [], //선택된 옵션들
      securityYn: null,
      securityList: [], //선택된 보안시설
      petYn: null, //반려동물 가능여부
      possibleVisitDays: [], //방문 가능 요일
      possibleVisitTimes: [], //방문 가능 시간

      selects: {
        // BIO: [],
        // PTT: [],
        PTTMap: {}
        // ETT: [],
        // HTT: [],
        // HFT: [],
        // MPM: [],
        // USR: [],
        // VPD: [],
        // VPT: [],
        // MTN: [],
        // SCF: [],
        // DRT: [],
        // UUF: [],
        // DST: []
      },

      // clsfData: [
      //   {
      //     clsfByJv: "아파트",
      //     purpsDetail: "아파트",
      //     purps: "공동주택"
      //   },
      //   {
      //     clsfByJv: "빌라",
      //     purpsDetail: "다세대, 연립",
      //     purps: "공동주택"
      //   },
      //   {
      //     clsfByJv: "주택",
      //     purpsDetail: "단독, 다중, 다가구",
      //     purps: "단독주택"
      //   },
      //   {
      //     clsfByJv: "오피스텔",
      //     purpsDetail: "업무시설(오피스텔)",
      //     purps: "업무시설"
      //   },
      //   {
      //     clsfByJv: "원룸",
      //     purpsDetail: "정의되어 있지 않음",
      //     purps: "정의되어 있지 않음"
      //   }
      // ],

      extrExpl: null, //추가설명
      oneHouseAgr: null, //단독주택일 경우 동의 체크박스
      shareHouseAgr: null, //공동주택일 경우 동의 체크박스

      G_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: []
      },

      etcComment: null, //기타 의견

      isEtv: false // extraValidation 에 걸렸는지 //===============================================================================20201106 him

      //끝
    };
  },
  created() {
    this.bringData();
    this.applyCommonCode();
  },
  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    contractInfo() {
      return this.sessionPropertyInquiry.contractInfo;
    },

    purps() {
      if (this.certification.purpsDetail != null) {
        const purp = this.certification.purpsDetail;
        if (
          purp.search("아파트") != -1 ||
          purp.search("다세대") != -1 ||
          purp.search("연립") != -1 ||
          purp.search("공동주택") != -1
        ) {
          return "PBH";
        } else if (
          purp.search("단독") != -1 ||
          purp.search("다중") != -1 ||
          purp.search("다가구") != -1
        ) {
          return "SFH";
        } else if (
          purp.search("오피스텔") != -1 ||
          purp.search("업무시설") != -1
        ) {
          return "BSF";
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    ///BuilldingInfo
    // purpString() {
    //   if (this.certification.purpsDetail != null) {
    //     const purp = this.certification.purpsDetail;
    //     if (
    //       purp.search("아파트") != -1 ||
    //       purp.search("다세대") != -1 ||
    //       purp.search("연립") != -1 ||
    //       purp.search("공동주택") != -1
    //     ) {
    //       return "공동주택";
    //     } else if (
    //       purp.search("단독") != -1 ||
    //       purp.search("다중") != -1 ||
    //       purp.search("다가구") != -1
    //     ) {
    //       return "단독주택";
    //     } else if (
    //       purp.search("오피스텔") != -1 ||
    //       purp.search("업무시설") != -1
    //     ) {
    //       return "업무시설";
    //     } else {
    //       return null;
    //     }
    //   } else {
    //     return null;
    //   }
    // },

    // fullAddr() {
    //   if (
    //     this.sessionPropertyInquiry.certification.fullRAddr == null ||
    //     this.sessionPropertyInquiry.certification.fullJAddr == null
    //   ) {
    //     return "도로명: " + "\n" + "지번:";
    //   } else {
    //     return (
    //       "도로명: " +
    //       this.sessionPropertyInquiry.certification.fullRAddr +
    //       "\n" +
    //       "지번:" +
    //       this.sessionPropertyInquiry.certification.fullJAddr
    //     );
    //   }
    // },

    // MoreInfo
    // supplyAreaP() {
    //   return Math.round(this.finalProvArea * 0.3025);
    // },
    // useAreaP() {
    //   return Math.round(this.finalUseArea * 0.3025);
    // },

    modifiedDong() {
      if (
        this.certification.AddrDong != null &&
        this.certification.AddrDong.charAt(
          this.certification.AddrDong.length - 1
        ) == "동"
      ) {
        return this.certification.AddrDong.slice(0, -1);
      } else if (this.certification.AddrDong != null) {
        return this.certification.AddrDong;
      } else {
        return null;
      }
    },

    modifiedHo() {
      if (
        this.certification.AddrHo != null &&
        this.certification.AddrHo.charAt(
          this.certification.AddrHo.length - 1
        ) == "호"
      ) {
        return this.certification.AddrHo.slice(0, -1);
      } else if (this.certification.AddrHo != null) {
        return this.certification.AddrHo;
      } else {
        return null;
      }
    },

    // MoreInfo
    // modifiedFlr() {
    //   if (
    //     this.certification.AddrFloor != null &&
    //     this.certification.AddrFloor.charAt(
    //       this.certification.AddrFloor.length - 1
    //     ) == "층"
    //   ) {
    //     return this.certification.AddrFloor.slice(0, -1);
    //   } else {
    //     return this.certification.AddrFloor;
    //   }
    // },

    ///BuilldingInfo
    // brdListForInput() {
    //   let brdL = "";

    //   if (this.certification.brdList != null) {
    //     if (this.certification.brdList.length == 1) {
    //       return this.certification.brdList[0];
    //     } else {
    //       for (var i = 0; i < this.certification.brdList.length - 1; i++) {
    //         brdL = brdL + this.certification.brdList[i] + ",";
    //       }
    //       return (
    //         brdL +
    //         this.certification.brdList[this.certification.brdList.length - 1]
    //       );
    //     }
    //   } else {
    //     return null;
    //   }
    // },

    modifiedPMD() {
      let PMD = this.possibleMoveDate;
      if (PMD != "0000-00-00") {
        PMD = this.$moment(PMD).format("YYYY-MM-DD");
        return PMD;
      } else {
        return PMD;
      }
    },
    /// ContractInfo
    // paymentType() {
    //   if (this.contractInfo.leaseYn == true) {
    //     return "전세";
    //   } else if (this.contractInfo.leaseYn == false) {
    //     return "월세";
    //   }
    // },

    // ContractInfo
    // deposit() {
    //   return (this.contractInfo.deposit / 10000).toFixed(0);
    // },

    // TranactionInfo
    // monthlyPay() {
    //   return (this.contractInfo.monthlyPay / 10000).toFixed(0);
    // },
    isOnlyRoom() {
      if (this.TNORooms == 1) {
        return true;
      } else {
        return false;
      }
    },

    isUseFee() {
      if (this.useFee == "1") {
        return true;
      } else {
        return false;
      }
    },

    finalProvArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.provArea;
      }
    }

    // MoreInfo
    // finalUseArea() {
    //   if (this.certification.partArea != 0) {
    //     return this.certification.partArea;
    //   } else {
    //     return this.certification.useArea;
    //   }
    // }
  },
  watch: {},

  mounted() {
    // if (window.kakao && window.kakao.maps) {
    //   this.initMap();
    // } else {
    //   const script = document.createElement("script");
    //   /* global kakao */
    //   const serviceKey = process.env.VUE_APP_KKO_SDK_KEY;
    //   script.onload = () => kakao.maps.load(this.initMap);
    //   script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${serviceKey}&libraries=services`;
    //   // <head></head>에 위치
    //   document.head.appendChild(script);
    // }
  },

  methods: {
    //===========================================================20201106 him
    // resizeMap() {
    //   this.jipvioMap.relayout();
    // },

    ...sessionMapActions(["savePropertyInquiryStep4"]),

    bringData() {
      this.locationInfo = this.sessionPropertyInquiry.propertyInfo.locationInfo;

      /* ContractInfo */
      // this.possibleMoveDate = this.sessionPropertyInquiry.propertyInfo.pmdNotMdf; // 입주가능일
      // this.imdMove = this.sessionPropertyInquiry.propertyInfo.imdMove; // 즉시입주(true, false)
      // if (this.sessionPropertyInquiry.propertyInfo !== null) {
      //   this.loanYn = Number(
      //     this.sessionPropertyInquiry.propertyInfo.loanYn
      //   ).toString(); //전세자금대출 가능여부
      // }

      /* MoreInfo */
      // this.TNORooms = this.sessionPropertyInquiry.propertyInfo.TNORooms; //방 수
      // this.TNORoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNORoomsDirect; // 방 수 직접선택 체크박스
      // this.TNOBathRooms = this.sessionPropertyInquiry.propertyInfo.TNOBathRooms; //욕실 수
      // this.TNOBathRoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNOBathRoomsDirect; //욕실 수 직접선택 체크박스
      // this.eleYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.eleYn
      // ).toString(); // 승강기 여부
      // this.heatingType = this.sessionPropertyInquiry.propertyInfo.heatingType; //난방방식
      // this.heatingFuel = this.sessionPropertyInquiry.propertyInfo.heatingFuel; //난방연료
      // this.entStructure = this.sessionPropertyInquiry.propertyInfo.entStructure; //현관구조
      // this.directionStd = this.sessionPropertyInquiry.propertyInfo.directionStd; //방향 기준
      // this.direction = this.sessionPropertyInquiry.propertyInfo.direction; //방향
      // this.verandaYn = this.sessionPropertyInquiry.propertyInfo.verandaYn; //베란다 체크박스
      // this.balconyYn = this.sessionPropertyInquiry.propertyInfo.balconyYn; // 발코니 체크박스
      // this.parkingYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.parkingYn
      // ).toString(); // 주차가능여부
      // this.PknPerFmly = Number(
      //   this.sessionPropertyInquiry.propertyInfo.PknPerFmly
      // ); // 가구당 주차가능대수
      // this.maintenanceFee = Number(
      //   this.sessionPropertyInquiry.propertyInfo.maintenanceFee
      // ); //관리비
      // this.maintenList = this.sessionPropertyInquiry.propertyInfo.maintenList; //선택된 관리비 포함항목
      // this.useFeeYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.useFeeYn
      // ).toString(); //사용료 유무
      // this.useFeeList = this.sessionPropertyInquiry.propertyInfo.useFeeList; //사용료 포함내역

      /* ExtraInfo */
      // this.optionYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.optionYn
      // ).toString(); //옵션유무
      // this.optionList = this.sessionPropertyInquiry.propertyInfo.optionList; //선택된 옵션들
      // this.securityYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.securityYn
      // ).toString();
      // this.securityList = this.sessionPropertyInquiry.propertyInfo.securityList; //선택된 보안시설
      // this.petYn = Number(
      //   this.sessionPropertyInquiry.propertyInfo.petYn
      // ).toString(); //반려동물 가능여부
      // this.possibleVisitDays = this.sessionPropertyInquiry.propertyInfo.possibleVisitDays; //방문 가능 요일
      // this.possibleVisitTimes = this.sessionPropertyInquiry.propertyInfo.possibleVisitTimes; //방문 가능 시간

      //나머지
      // this.extrExpl = this.sessionPropertyInquiry.propertyInfo.extrExpl; //추가설명

      // this.oneHouseAgr = this.sessionPropertyInquiry.propertyInfo.oneHouseAgr; //단독주택일 경우 동의 체크박스
      // this.shareHouseAgr = this.sessionPropertyInquiry.propertyInfo.shareHouseAgr; //공동주택일 경우 동의 체크박스

      // this.G_Img_File = this.sessionPropertyInquiry.propertyInfo.G_Img_File; //일반이미지

      // this.etcComment = this.sessionPropertyInquiry.propertyInfo.etcComment; //기타 의견
    },

    GetContractData(data) {
      (this.imdMove = data.imdMove),
        (this.possibleMoveDate = data.possibleMoveDate),
        (this.loanYn = data.loanYn);
    },

    GetDetailData(data) {
      (this.TNORooms = data.TNORooms),
        (this.TNORoomsDirect = data.TNORoomsDirect),
        (this.TNOBathRooms = data.TNOBathRooms),
        (this.TNOBathRoomsDirect = data.TNOBathRoomsDirect),
        (this.eleYn = data.eleYn),
        (this.heatingType = data.heatingType),
        (this.heatingFuel = data.heatingFuel),
        (this.entStructure = data.entStructure),
        (this.directionStd = data.directionStd),
        (this.direction = data.direction),
        (this.verandaYn = data.verandaYn),
        (this.balconyYn = data.balconyYn),
        (this.parkingYn = data.parkingYn),
        (this.PknPerFmly = data.PknPerFmly),
        (this.maintenanceFee = data.maintenanceFee),
        (this.maintenList = data.maintenList),
        (this.useFeeYn = data.useFeeYn),
        (this.useFeeList = data.useFeeList);
    },

    GetExtraData(data) {
      (this.optionYn = data.optionYn),
        (this.optionList = data.optionList),
        (this.securityYn = data.securityYn),
        (this.securityList = data.securityList),
        (this.petYn = data.petYn),
        (this.possibleVisitDays = data.possibleVisitDays),
        (this.possibleVisitTimes = data.possibleVisitTimes);
    },

    bringComponetData() {
      this.$refs["contrInfo"].SendContractData();
      this.$refs["DetailInfo"].SendDetailData();
      this.$refs["ExtraInfo"].SendExtraData();
    },

    saveStep() {
      this.saveStep4Info();
    },

    saveStep4Info() {
      console.log("step4 Action!");
      let propertyInfo = {
        ownerName: this.certification.ownerName, //소유주 이름
        ownerAddr: this.certification.ownerAddr, // 소유주 주소
        ownerAddrDetail: this.certification.ownerAddrDetail, //소유주 상세주소
        ownerTel: this.certification.ownerTel, // 소유주 휴대폰

        propertyJAddr: this.certification.propertyJAddr, //건물 지번 주소
        propertyRAddr: this.certification.propertyRAddr, //건물 도로명 주소
        propertyLat: Number(this.certification.propertyLat), // 위도
        propertyLong: Number(this.certification.propertyLong), // 경도

        AddrDong: this.certification.AddrDong, //동
        AddrHo: this.certification.AddrHo, //호
        AddrFloor: this.certification.AddrFloor, //층
        flrJustNum: this.modifiedFlr, // 층 숫자만
        hoJustNm: this.modifiedHo, // 호 이름만
        dongJustNm: this.modifiedDong, // 동 이름만

        locationInfo: this.certification.locationInfo,
        fullRAddr: this.certification.fullRAddr, //주소+동호층 (도로명)
        fullJAddr: this.certification.fullJAddr, //주소+동호층 (지번)
        jiBun: this.certification.jiBun, // 지번주소의 지번
        legalDong: this.certification.legalDong, // 법정동

        allFloor: this.certification.allFloor, // 층 전체 체크박스
        partFloor: this.certification.partFloor, //층 일부 체크박스

        //=============================================
        strct: this.certification.strct, //건축물 구조
        rawBrdList: this.certification.brdList, // 용도지역 원본 리스트 (ex)['일반주거지역', '공업지역'])
        brdList: this.brdListForInput, // 용도지역 String (ex) 일반주거지역, 공업지역)
        purps: this.purps, //건축물 용도(건축법)
        purpsDetail: this.certification.purpsDetail, // 건축물 세부용도(api)
        jpvTypeCd: this.certification.jpvTypeCd, //아파트, 빌라, 주택, 오피스텔
        isOnlyRoom: this.isOnlyRoom, //원룸 여부
        platArea: this.certification.platArea, // 대지면적
        totArea: this.certification.totArea, // 연면적
        hhldCnt: this.certification.hhldCnt, // 총 세대수
        bdNm: this.certification.bdNm, // 건축물 명
        permitDate: this.certification.useAprDay, //사용승인 일자
        totPkngCnt: this.certification.totPkngCnt, //총 주차대수

        paymentType: this.selects.PTTMap[this.paymentType], //거래유형
        deposit: Number(this.contractInfo.deposit), //보증금
        monthlyPay: Number(this.contractInfo.monthlyPay), //월세
        pmdNotMdf: this.possibleMoveDate, // 포맷 수정 안된 입주가능일(불러오기 용도)
        possibleMoveDate: this.modifiedPMD, // formmat수정 입주가능일
        imdMove: this.imdMove, // 즉시입주(true, false)
        loanYn: Boolean(Number(this.loanYn)), //전세자금대출 가능여부

        provArea: this.finalProvArea, // 공급면적
        useArea: this.finalUseArea, //전용면적
        grndFlrCnt: this.certification.grndFlrCnt, //총 층
        TNORooms: Number(this.TNORooms), //방 수
        TNORoomsDirect: this.TNORoomsDirect, //방개수 직접입력인지 아닌지
        TNOBathRooms: Number(this.TNOBathRooms), //욕실 수
        TNOBathRoomsDirect: this.TNOBathRoomsDirect, //욕실개수 직접입력인지 아닌지
        eleYn: Boolean(Number(this.eleYn)), // 승강기 여부
        heatingType: this.heatingType, //난방방식
        heatingFuel: this.heatingFuel, //난방연료
        entStructure: this.entStructure, //현관구조
        directionStd: this.directionStd, //방향 기준
        direction: this.direction, //방향
        verandaYn: this.verandaYn, //베란다 체크박스
        balconyYn: this.balconyYn, // 발코니 체크박스
        parkingYn: Boolean(Number(this.parkingYn)), // 주차가능여부
        PknPerFmly: Number(this.PknPerFmly), // 가구당 주차가능대수
        maintenanceFee: Number(this.maintenanceFee) * 10000, //관리비
        maintenList: this.maintenList, //선택된 관리비 포함항목
        useFeeYn: Boolean(Number(this.useFeeYn)), //사용료
        useFeeList: this.useFeeList, //선택된 사용료 포함항목

        optionYn: Boolean(Number(this.optionYn)), //옵션 유무
        optionList: this.optionList, //선택된 옵션들
        securityYn: Boolean(Number(this.securityYn)), //보안시설 유무
        securityList: this.securityList, //선택된 보안시설
        petYn: Boolean(Number(this.petYn)), // 반려동물 가능여부
        possibleVisitDays: this.possibleVisitDays, //방문 가능 요일
        possibleVisitTimes: this.possibleVisitTimes, //방문 가능 시간

        extrExpl: this.extrExpl, //매물 추가 설명

        oneHouseAgr: this.oneHouseAgr, // 추가정보 동의 YN (단독주택 경우)
        shareHouseAgr: this.shareHouseAgr, // 추가정보 동의 YN (공동주택 경우)

        G_Img_File: this.G_Img_File, // 일반이미지

        etcComment: this.etcComment //기타 의견
      };
      this.savePropertyInquiryStep4(propertyInfo);
      console.log(this.sessionPropertyInquiry);
    },

    extraValidation() {
      this.isEtv = false;
      let errMsg = [];

      if (this.maintenanceFee != 0 && this.maintenList.length == 0) {
        errMsg.push({
          message: "관리비 포함내역을 확인해주세요.",
          ref: "DetailInfo"
        });
      }

      if (this.G_Img_File.fileList.length < 1) {
        errMsg.push({
          message: " 사진을 등록해주세요.",
          ref: "FileUpload"
        });
      }

      if (
        this.G_Img_File.fileList.length > 0 &&
        this.G_Img_File.fileList
          .map(file => file.size)
          .reduce((acc, curr) => acc + curr) >
          100 * 1000 * 1000
      ) {
        errMsg.push({
          message: " 일반 사진 전체 크키는 100MB를 초과할 수 없습니다.",
          ref: "FileUpload"
        });
      }

      if (errMsg.length > 0) {
        this.isEtv = true;
        for (let i = 0; i < errMsg.length; i++) {
          Message({
            message: errMsg[i]["message"],
            type: "error",
            offset: (i + 1) * 35
          });
        }
        setTimeout(() => {
          this.$refs[errMsg[0].ref].$el.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }, 120);
      }

      // if (errMsg[0] != null) {
      //   this.isEtv = true;

      //   this.$nextTick(() => {
      //     this.$refs[errMsg[0].ref].document
      //       .getElementById(errMsg[0].focusId)
      //       .focus();
      //   });
      //   Message({
      //     message: errMsg[0].message,
      //     type: "error"
      //   });
      // }

      // if (errMsg[1] != null) {
      //   Message({
      //     message: errMsg[1].message,
      //     type: "error",
      //     offset: 60
      //   });
      // }

      // if (errMsg[2] != null) {
      //   Message({
      //     message: errMsg[2].message,
      //     type: "error",
      //     offset: 100
      //   });
      // }

      // if (errMsg[3] != null) {
      //   Message({
      //     message: errMsg[3].message,
      //     type: "error",
      //     offset: 140
      //   });
      // }
    },

    // async showMessage() {
    //   let errMsg = [];

    //   let res = await this.$refs[
    //     "contrInfo"
    //   ].$refs.possibleMoveDateVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "입주 가능일을 확인해주세요.",
    //       focusId: "ler_step4_contrInfo",
    //       ref: "contrInfo"
    //     });
    //   }

    //   res = await this.$refs["contrInfo"].$refs.loanYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "전세자금대출 가능여부를 확인해주세요.",
    //       focusId: "ler_step4_contrInfo",
    //       ref: "contrInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.TNORoomsVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "방 수를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.TNOBathRoomsVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "욕실 수를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.eleYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "승강기 유무를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.heatingTypeVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "난방방식을 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.heatingFuelVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "난방연료를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.entStructureVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "현관구조를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.directionStdVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "방향 기준을 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.directionVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "방향을 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.parkingYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "주차가능대수를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   if (Number(this.parkingYn) === 1) {
    //     res = await this.$refs["DetailInfo"].$refs.pknPerFmlyVal.validate();
    //     if (!res.valid) {
    //       errMsg.push({
    //         message: "가구 당 주차대수를 입력해주세요.",
    //         focusId: "ler_step4_detailInfo",
    //         ref: "DetailInfo"
    //       });
    //     }
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.maintenanceFeeVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "관리비를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   res = await this.$refs["DetailInfo"].$refs.useFeeYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "사용료를 확인해주세요.",
    //       focusId: "ler_step4_detailInfo",
    //       ref: "DetailInfo"
    //     });
    //   }

    //   if (Number(this.useFeeYn) === 1) {
    //     res = await this.$refs[
    //       "DetailInfo"
    //     ].$refs.useFeeListSelectVal.validate();
    //     if (!res.valid) {
    //       errMsg.push({
    //         message: "사용료 항목을 선택해주세요.",
    //         focusId: "ler_step4_detailInfo",
    //         ref: "DetailInfo"
    //       });
    //     }
    //   }

    //   res = await this.$refs["ExtraInfo"].$refs.optionYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "옵션을 확인해주세요.",
    //       focusId: "ler_step4_extrInfo",
    //       ref: "ExtraInfo"
    //     });
    //   }

    //   if (Number(this.optionYn) === 1) {
    //     res = await this.$refs[
    //       "ExtraInfo"
    //     ].$refs.optionListSelectVal.validate();
    //     if (!res.valid) {
    //       errMsg.push({
    //         message: "옵션 항목을 선택해주세요.",
    //         focusId: "ler_step4_extrInfo",
    //         ref: "ExtraInfo"
    //       });
    //     }
    //   }

    //   res = await this.$refs["ExtraInfo"].$refs.securityYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "보안시설을 확인해주세요.",
    //       focusId: "ler_step4_extrInfo",
    //       ref: "ExtraInfo"
    //     });
    //   }

    //   if (Number(this.securityYn) === 1) {
    //     res = await this.$refs[
    //       "ExtraInfo"
    //     ].$refs.securityListSelectVal.validate();
    //     if (!res.valid) {
    //       errMsg.push({
    //         message: "보안시설 항목을 선택해주세요.",
    //         focusId: "ler_step4_extrInfo",
    //         ref: "ExtraInfo"
    //       });
    //     }
    //   }

    //   res = await this.$refs["ExtraInfo"].$refs.petYnVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "반려동물 가능여부를 확인해주세요.",
    //       focusId: "ler_step4_extrInfo",
    //       ref: "ExtraInfo"
    //     });
    //   }

    //   res = await this.$refs["ExtraInfo"].$refs.possibleVisitDaysVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "방문 가능 요일을 확인해주세요.",
    //       focusId: "ler_step4_extrInfo",
    //       ref: "ExtraInfo"
    //     });
    //   }

    //   res = await this.$refs[
    //     "ExtraInfo"
    //   ].$refs.possibleVisitTimesVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "방문 가능 시간을 확인해주세요.",
    //       focusId: "ler_step4_extrInfo",
    //       ref: "ExtraInfo"
    //     });
    //   }

    //   if (errMsg[0] != null) {
    //     console.log(this.$refs[errMsg[0].ref]);
    //     this.$nextTick(() => {
    //       this.$refs[errMsg[0].ref].$el.focus();
    //     });
    //     Message({
    //       message: errMsg[0].message,
    //       type: "error"
    //     });
    //   }

    //   if (errMsg[1] != null) {
    //     Message({
    //       message: errMsg[1].message,
    //       type: "error",
    //       offset: 60
    //     });
    //   }

    //   if (errMsg[2] != null) {
    //     Message({
    //       message: errMsg[2].message,
    //       type: "error",
    //       offset: 100
    //     });
    //   }
    // },

    showMessage(ValId) {
      if (ValId == "possibleMoveDateVal") {
        return "입주 가능일을 확인해주세요.";
      } else if (ValId == "loanYnVal") {
        return "전세자금대출 가능여부를 확인해주세요.";
      } else if (ValId == "TNORoomsVal") {
        return "방 수를 확인해주세요.";
      } else if (ValId == "TNOBathRoomsVal") {
        return "욕실 수를 확인해주세요.";
      } else if (ValId == "eleYnVal") {
        return "승강기 유무를 확인해주세요.";
      } else if (ValId == "heatingTypeVal") {
        return "난방방식을 확인해주세요.";
      } else if (ValId == "heatingFuelVal") {
        return "난방연료를 확인해주세요.";
      } else if (ValId == "entStructureVal") {
        return "현관구조를 확인해주세요.";
      } else if (ValId == "directionStdVal") {
        return "방향 기준을 확인해주세요.";
      } else if (ValId == "directionVal") {
        return "방향을 확인해주세요.";
      } else if (ValId == "parkingYnVal") {
        return "주차가능대수를 확인해주세요.";
      } else if (ValId == "pknPerFmlyVal") {
        return "가구 당 주차대수를 입력해주세요.";
      } else if (ValId == "maintenanceFeeVal") {
        return "관리비를 확인해주세요.";
      } else if (ValId == "useFeeYnVal") {
        return "사용료를 확인해주세요.";
      } else if (ValId == "useFeeListSelectVal") {
        return "사용료 항목을 선택해주세요.";
      } else if (ValId == "optionYnVal") {
        return "옵션을 확인해주세요.";
      } else if (ValId == "optionListSelectVal") {
        return "옵션 항목을 선택해주세요.";
      } else if (ValId == "securityYnVal") {
        return "보안시설을 확인해주세요.";
      } else if (ValId == "securityListSelectVal") {
        return "보안시설 항목을 선택해주세요.";
      } else if (ValId == "petYnVal") {
        return "반려동물 가능여부를 확인해주세요.";
      } else if (ValId == "possibleVisitDaysVal") {
        return "방문 가능 요일을 확인해주세요.";
      } else if (ValId == "possibleVisitTimesVal") {
        return "방문 가능 시간을 확인해주세요.";
      }
    },

    validate() {
      console.log(this.$refs.form.errors);
      return this.$refs.form.validate().then(async isValid => {
        if (!isValid) {
          setTimeout(() => {
            // 에러가 발생한 부분만 Array로 만들기
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error["value"].length);

            for (let i = 0; i < errors.length; i++) {
              Message({
                message: this.showMessage(errors[i]["key"]),
                type: "error",
                offset: (i + 1) * 35
              });
            }

            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }, 100);
          return;
        }
        this.bringComponetData();
        this.extraValidation();

        if (this.isEtv) {
          return;
        }

        await this.saveStep4Info();
        this.$emit("on-validated", isValid);
        return isValid;
      });
    },

    //=================================================================

    printData() {
      console.log(this.loanYn);
    },

    //===============================================================================20201106 him
    // initMap() {
    //   console.log("step4 initmap");
    //   const container = document.getElementById("step4Map");
    //   const pptLat = this.certification.propertyLat;
    //   const pptLong = this.certification.propertyLong;

    //   const options = {
    //     // required : 위도(latitude), 경도(longitude)
    //     center: new kakao.maps.LatLng(pptLat, pptLong),
    //     level: 3
    //   };

    //   this.jipvioMap = new kakao.maps.Map(container, options);
    //   this.jipvioGeocoder = new kakao.maps.services.Geocoder();

    //   // 마커를 생성합니다
    //   var marker = new kakao.maps.Marker({
    //     position: new kakao.maps.LatLng(pptLat, pptLong), // 마커를 표시할 위치
    //     title: "카카오" // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
    //   });
    //   this.jipvioMarker = marker;

    //   this.jipvioMarker.setMap(this.jipvioMap);
    // },

    //===============================================================================20201106 him
    // changeMap() {
    //   console.log("step4 changeMap");

    //   //마크 지우기
    //   this.jipvioMarker.setMap(null);
    //   this.jipvioMarker = null;

    //   console.log("step4 change map");

    //   this.jipvioGeocoder.addressSearch(
    //     this.locationInfo.roadFullAddr,
    //     function(result, status) {
    //       console.log("지오코더");
    //       console.log(result);
    //       if (status === kakao.maps.services.Status.OK) {
    //         var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

    //         //마커 생성
    //         var marker = new kakao.maps.Marker({
    //           // map: self.jipvioMap,
    //           position: coords
    //         });

    //         this.jipvioMarker = marker;
    //         this.jipvioMarker.setMap(this.jipvioMap);

    //         //센터 이동
    //         this.jipvioMap.setCenter(coords);
    //       }
    //     }
    //   );
    // },

    applyCommonCode() {
      // // console.log(this.sessionCoCodeMap);
      // //BIO========================================================
      // this.sessionCoCodeMap.BIO.forEach((ele, dex) => {
      //   this.selects.BIO.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        // this.selects.PTT.push({
        //   value: ele.code,
        //   label: ele.name
        // });
        this.selects.PTTMap[ele.name] = ele.code;
      });
      // //ETT========================================================
      // this.sessionCoCodeMap.ETT.forEach((ele, dex) => {
      //   this.selects.ETT.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //HTT========================================================
      // this.sessionCoCodeMap.HTT.forEach((ele, dex) => {
      //   this.selects.HTT.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //HFT========================================================
      // this.sessionCoCodeMap.HFT.forEach((ele, dex) => {
      //   this.selects.HFT.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //MPM========================================================
      // this.sessionCoCodeMap.MPM.forEach((ele, dex) => {
      //   this.selects.MPM.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //USR========================================================
      // this.sessionCoCodeMap.USR.forEach((ele, dex) => {
      //   this.selects.USR.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //VPD========================================================
      // this.sessionCoCodeMap.VPD.forEach((ele, dex) => {
      //   this.selects.VPD.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //VPT========================================================
      // this.sessionCoCodeMap.VPT.forEach((ele, dex) => {
      //   this.selects.VPT.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //MTN========================================================
      // this.sessionCoCodeMap.MTN.forEach((ele, dex) => {
      //   this.selects.MTN.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //SCF========================================================
      // this.sessionCoCodeMap.SCF.forEach((ele, dex) => {
      //   this.selects.SCF.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //DRT========================================================
      // this.sessionCoCodeMap.DRT.forEach((ele, dex) => {
      //   this.selects.DRT.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //UUF========================================================
      // this.sessionCoCodeMap.UUF.forEach((ele, dex) => {
      //   this.selects.UUF.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // //DST========================================================
      // this.sessionCoCodeMap.DST.forEach((ele, dex) => {
      //   this.selects.DST.push({
      //     value: ele.code,
      //     label: ele.name
      //   });
      // });
      // console.log("----------");
      // console.log(this.selects);
    }

    // TNORoomsDirectWrite() {
    //   if (this.TNORooms == "null") {
    //     this.TNORooms = null;
    //     this.TNORoomsDirect = true;
    //   } else {
    //     this.TNORoomsDirect = false;
    //   }
    // },

    // TNOBathRoomsDirectWrite() {
    //   if (this.TNOBathRooms == "null") {
    //     this.TNOBathRooms = null;
    //     this.TNOBathRoomsDirect = true;
    //   } else {
    //     this.TNOBathRoomsDirect = false;
    //   }
    //   console.log(this.TNOBathRoomsDirect);
    // },

    // delPMD() {
    //   if (this.imdMove == true) {
    //     this.possibleMoveDate = "0000-00-00";
    //   } else {
    //     this.possibleMoveDate = null;
    //   }
    //   console.log(this.possibleMoveDate);
    // },

    // 파일첨부시(업로드x) 이벤트
    // uploadChange: function(file, fileList) {
    //   console.log("fileList: ", fileList);
    //   this.G_Img_File.fileList = fileList;
    //   this.G_Img_File.fileList.forEach(file => {
    //     if (file.size > 50 * 1000 * 1000) {
    //       Message.error("50MB이상 파일은 업로드할 수 없습니다.");
    //       this.G_Img_File.fileList.splice(
    //         this.G_Img_File.fileList.indexOf(file),
    //         1
    //       );
    //       return;
    //     }
    //   });
    // },
    // // 선택한 파일 삭제
    // removeFile: function(file, fileList) {
    //   this.G_Img_File.fileList = fileList;
    //   // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
    //   console.log(file);
    //   if (file.raw === undefined) this.G_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    // },
    // // 지정한 파일갯수를 초과해서 첨부했을 때
    // exceedFileLimit: function() {
    //   Message.warning("파일첨부는 3개까지만 가능합니다.");
    // }
  }
};
</script>
<style>
.jipvio-rad div.el-card {
  outline: none;
}
.jipvio-rad h3 {
  color: #797979;
  text-align: center;
}
.jipvio-rad h4,
h5 {
  color: #797979;
}

.AddrDetailLabel {
  width: 10%;
}

.AddrDetailSelect {
  width: 88%;
  margin-left: 2px;
}

.AreaIcon {
  font-size: 20px;
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.propInfoTitle {
  color: #6988e6;
  font-size: 19px;
  font-weight: bold;
}

#step4p1 {
  color: #6988e6;
  font-size: 15px;
  font-weight: bold;
}

.TNORooms_wdth {
  width: 30%;
}

.maintenanceFee input.form-control {
  width: 76%;
}
.maintenanceFee label {
  width: 24%;
  float: right;
  padding-left: 10px;
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  line-height: 1.5;
}
#maintenancefeelistlabel {
  float: left;
}

.pptInquiry_addData_Ul {
  padding: 10px;
}
.pptInquiry_addData_Ul > li {
  list-style: decimal;
}

/* div.jipvio-bg-white .form-group .el-input__inner[readonly] {
  background-color: #ffffff;
} */

#ler_step4_GImgUpl div.el-upload.el-upload--text {
  width: 100%;
}
#ler_step4_GImgUpl div.el-upload-dragger {
  width: 100%;
}
</style>
